import instanceQuery from '../../../graphql/queries/web/WebMediaFileQuery.graphql';
import defaultQuery from '../../../graphql/queries/web/WebMediaFileDefault.graphql';
import mutationQuery from '../../../graphql/mutations/web/WebMediaFileMutation.graphql';
import fragment from '../../../graphql/fragments/web/WebMediaFileFragment.graphql';

const WebMediaFile = {
  type: 'WebMediaFile',
  title: 'Web Media File',
  formTitle: 'Web Media File',
  formUrl: '/Web/Media/Details/',
  workspaceUrl: '/Web/Media/Treespace/',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  returnUrl: '/menu/Web',
  fragment,
  screenReference: 'WEB_MEDIA_FILES',
};

export default WebMediaFile;
